// The market chart: new SIMAP tenders per day (GET /tenders/stats/daily,
// zero-filled by the backend) with a rolling average, and the CSV of the
// same numbers.
import { csvLine } from './csv';

export interface DailyCount {
    date: string;      // YYYY-MM-DD
    tenders: number;   // projects whose first tender publication is that day
}

export interface DailyTenderStats {
    from: string;
    to: string;
    days: DailyCount[];
}

export const ROLLING_WINDOW = 7;

// Mean of the window ending on each day (shorter at the start), one decimal.
export function rollingMean(values: number[], window: number): number[] {
    const out: number[] = [];
    let sum = 0;
    for (let i = 0; i < values.length; i++) {
        sum += values[i];
        if (i >= window) sum -= values[i - window];
        const n = Math.min(i + 1, window);
        out.push(Math.round((sum / n) * 10) / 10);
    }
    return out;
}

export function dailyStatsCsv(days: DailyCount[]): string {
    const mean = rollingMean(days.map(d => d.tenders), ROLLING_WINDOW);
    const lines = [csvLine(['Date', 'New tenders', `${ROLLING_WINDOW}-day average`])];
    days.forEach((d, i) => lines.push(csvLine([d.date, d.tenders, mean[i]])));
    return lines.join('\n');
}

export function statsFilename(now: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `tenders_per_day_${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}.csv`;
}
